import React from 'react';
import Grid from './Grid';
import './Layout.css';
import Calendar from 'react-calendar';
import { Manager, Reference, Popper } from 'react-popper';

function Content() {
  return ( 
    <div className="content">

      <section className="sidebar">
         <Calendar className="calendar" />
         <h3 className="sidebar-title">Today</h3>

         <hr className="sidebar-line"></hr>
         <p>Radio Activities    10 minutes </p>
        <p>Firebase Connect.. 1 hours</p>
        <h3 className="sidebar-title">Upcoming live</h3>
         <hr className="sidebar-line"></hr>
         <p>React Native  29 days</p>
        <p>iOS Development  32 days</p>
        
        <button className="sidebar-button-wiki">WIKI</button>
        <button className="sidebar-button-chat">CHAT</button>
        <button className="sidebar-button-help">HELP</button>

      </section>


      <section className="video-content">
      <h1 className="title">LIVE COURSE</h1>
      <section className="live-course">
      <Grid 
      url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
      time="March 8.2020 9:30am to 4:30pm Central Time"
      title="Connecting Firebase to a contact Form"
      author="Sam Lessin"

      />
      <Grid
      url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
      time="March 8.2020 9:30am to 4:30pm Central Time"
      title="JSON Files Introduction"
      author="Sam Lessin"
      
      />
      <Grid
      url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
      time="March 8.2020 9:30am to 4:30pm Central Time"
      title="Firebase File Upload using firebase cloud storage"
      author="Sam Lessin"
      />
      <Grid
      url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
      time="March 8.2020 9:30am to 4:30pm Central Time"
      title="Algorithms Courses from a Google Engineer"
      author="Sam Lessin"
      />
      </section>
      <hr></hr>
      <h1 className="title">You are learning</h1>

      <section className="you-are-learning">
      <Grid
            url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
            title="Justice in Society"
            author="John Lessin"/>
      <Grid
       url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
       title="Airbnb Interview Introduction"
       author="John Lessin"/>
      <Grid
       url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
       title="Connecting Firebase to html/css"
       author="Lucy Luna"/>
    
      <Grid
             url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
             title="2020 Web Development"
             author="Sam Sunny"/>
      </section>
      <hr></hr>

      <h1 className="title">Upcoming Course</h1>

      <section className="upcoming-course">
      <Grid             url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
             title="MangoDB Introduction"
             author="Sam Sunny"/>
      <Grid             url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
             title="Welcome to Javascript"
             author="Sam Sunny"/>
      <Grid
                   url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                   title="10 things you should know as full-stack developer"
                   author="Sam Sunny"/>

      <Grid
                   url="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                   title="Interview tips towards software engineer"
                   author="Sam Sunny"/>
      <hr></hr>
      </section>
      </section>
    </div>

  )
}



export default Content;